import { Card } from "@tellescope/design-system";
import type { CardBlock as CardBlockType } from "../../../shared/schema";

interface CardBlockProps {
  title?: CardBlockType["props"]["title"];
  description?: CardBlockType["props"]["description"];
}

export const CardBlock: React.FC<CardBlockProps> = ({ title, description }) => {
  // Don't render empty cards
  if (!title && !description) return null;

  return (
    <Card variant="floating" padding="root">
      <Card.Header>
        {title && <Card.Title className="min-w-0 break-words">{title}</Card.Title>}
        {description && <Card.Description className="min-w-0 break-words">{description}</Card.Description>}
      </Card.Header>
    </Card>
  );
};
